"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stacks 2.0 Blockchain API
 * This is the documentation for the Stacks 2.0 Blockchain API.  It is comprised of two parts; the Stacks Blockchain API and the Stacks Core API.  <a href=\"collection.json\" download=\"collection.json\">Download Postman collection</a>
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RosettaOperationIdentifierToJSON = exports.RosettaOperationIdentifierFromJSONTyped = exports.RosettaOperationIdentifierFromJSON = void 0;
const runtime_1 = require("../runtime");
function RosettaOperationIdentifierFromJSON(json) {
    return RosettaOperationIdentifierFromJSONTyped(json, false);
}
exports.RosettaOperationIdentifierFromJSON = RosettaOperationIdentifierFromJSON;
function RosettaOperationIdentifierFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'index': json['index'],
        'network_index': !runtime_1.exists(json, 'network_index') ? undefined : json['network_index'],
    };
}
exports.RosettaOperationIdentifierFromJSONTyped = RosettaOperationIdentifierFromJSONTyped;
function RosettaOperationIdentifierToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'index': value.index,
        'network_index': value.network_index,
    };
}
exports.RosettaOperationIdentifierToJSON = RosettaOperationIdentifierToJSON;
//# sourceMappingURL=RosettaOperationIdentifier.js.map